import { Upload } from 'antd'
import ImgCrop from 'antd-img-crop'

import { getUploadImageFromCustomCompletePage } from '../../UtilsCompletePage/getUploadImageFromCustomCompletePage'
import { StateCustomPageEditorProps } from './CustomPageEditor'
const { Dragger } = Upload

export const CustomUpload = ({ data, setData }: StateCustomPageEditorProps) => {
  const handleFile = async (file: File) => {
    try {
      const base64 = await convertToBase64(file)

      const newContent =
        data
          ?.replace(/@icon\[[^\]]*]/, '')
          .replace(/@upload\[[^\]]*]/, '')
          .trim() ?? ''

      const finalContent = `@upload[${base64}]${newContent}`

      setData(finalContent)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error on upload image')
    }
  }

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = reject
    })
  }

  const preview = getUploadImageFromCustomCompletePage(data)

  return (
    <div className="flex h-[136px] w-[232px] items-center justify-center gap-2">
      <div className="relative h-32 w-32 overflow-hidden rounded border border-gray-200 bg-gray-50">
        <span className="absolute left-1/2 top-1/2 z-[1] -translate-x-1/2 -translate-y-1/2 select-none whitespace-nowrap text-gray-500">
          128 x 128px
        </span>
        {preview && (
          <img
            alt="Preview"
            className="relative z-[2] h-full w-full object-cover"
            src={preview}
          />
        )}
      </div>
      <ImgCrop>
        <Dragger
          accept="image/*"
          customRequest={({ file }) => {
            void handleFile(file as File)
          }}
          multiple={false}
          showUploadList={false}
        >
          <p className="text-gray-600">Upload +</p>
        </Dragger>
      </ImgCrop>
    </div>
  )
}
